import {isEventsRoutePath} from './events-search-params-sync'
import {submitSessionBridgeToNewPortal} from './submit-session-bridge-to-new-portal'

const EVENTS_DEEP_LINK_PARAMS = ['id', 'search', 'camera']

function normalizePath(pathname: string): string {
  return pathname.replace(/\/+$/, '') || '/'
}

function isEventsDeepLink(pathname: string, search: string): boolean {
  if (!isEventsRoutePath(pathname)) return false
  const params = new URLSearchParams(search)
  return EVENTS_DEEP_LINK_PARAMS.some((key) => Boolean(params.get(key)?.trim()))
}

function isDocsPath(pathname: string): boolean {
  return normalizePath(pathname) === '/docs'
}

export function redirectPastedDeepLinkToNewPortal(location: {pathname: string; search: string} = window.location): boolean {
  try {
    const shouldRedirect = isEventsDeepLink(location.pathname, location.search) || isDocsPath(location.pathname)
    if (!shouldRedirect) return false

    const result = submitSessionBridgeToNewPortal({
      legacyPath: location.pathname,
      search: location.search,
      forceRedirect: true,
    })

    return result.ok
  } catch {
    return false
  }
}
